export default __webpack_public_path__ + "static/media/signature.f7d8b229.png";